<template>
  <div>
    <div v-for="(item, i) in imgUrlList" :key="i+item" class="img_list">
      <el-image :src="baseimgurl+item" :preview-src-list="imgUrlList" :z-index="5000">
        <!-- 暂无图片 -->
        <div slot="error" class="image_slot">{{$t("common.t3")}}</div>
      </el-image>
      <div class="delete_btn" @click="deleteImg(item)">
        <i class="el-icon-delete"></i>
      </div>
    </div>

    <!-- 图片上传 -->
    <el-upload ref="ImgRef" class="upload_img" multiple :action="uploadUrl" :headers="upHeader" v-show="addShow" :on-success="upImg" :before-upload="beforeUpload" accept=".jpg,.png,.jpeg,.JPG,.PNG,.JPEG">
      <i class="el-icon-plus"></i>
    </el-upload>
  </div>

</template>

<script>
export default {
  name: "EditImg",
  props: {
    picture: String,
  },
  data: function () {
    return {
      addShow: true,
      imgUrlList: [],
      baseimgurl: this.common.imgUrl(),
      addImg: [], //添加的图片列表
      delImg: [], //删除的图片列表
      uploadUrl: this.common.uploadUrl(),
      // 请求头参数
      upHeader: {
        operator: JSON.parse(sessionStorage.getItem("user")).userAccount,
      },
    };
  },
  watch: {
    picture: function (newVal, oldVal) {
      if (newVal) {
        this.imgUrlList = newVal.split("#");
        this.addImg = []; //添加的图片列表
        this.delImg = []; //删除的图片列表
        this.maxImgNum();
      } else {
        this.imgUrlList = [];
        this.addImg = []; //添加的图片列表
        this.delImg = []; //删除的图片列表
      }
    },
  },

  methods: {
    // 上传前 文件检验
    beforeUpload(file) {
      let testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      let typeFlag = false; //类型标记
      // this.sameFlag = true; //相同标记
      const isLt2M = file.size / 1024 / 1024 < 5; //限制大小
      let picType = ["png", "jpg", "jpeg", "PNG", "JPG", "JPEG"]; //允许上传的类型
      // 图片后缀检验
      for (let i = 0; i < picType.length; i++) {
        if (testmsg == picType[i]) {
          typeFlag = true;
          break;
        }
      }
      if (!typeFlag) {
        this.$message({
          // 请上传jpg、jpeg或png格式的图片！
          message: this.$t("common.t4"),
          type: "warning",
        });
      }
      // 图片大小检验
      if (!isLt2M) {
        this.$message({
          // 上传图片大小不能超过 5MB!
          message: this.$t("common.t5"),
          type: "warning",
        });
      }
      // 改为手动上传后   失效
      return typeFlag && isLt2M;
    },

    // 取消编辑时恢复默认图片列表
    restore() {
      if (this.picture) {
        this.imgUrlList = this.picture.split("#");
        this.maxImgNum();
      } else {
        this.imgUrlList = [];
      }
    },

    maxImgNum() {
      if (this.imgUrlList.length >= 6) {
        this.addShow = false;
      }
    },
    // 上传图片成功
    upImg(res, file) {
      this.addImg.push(res.data); //记录添加的图片列表，用于取消编辑时删除
      this.imgUrlList.push(res.data);
      this.maxImgNum();

      this.$emit("editlist", this.imgUrlList, this.addImg, this.delImg);
    },

    deleteImg(item) {
      this.delImg.push(item); //记录
      this.addShow = true;
      // 剔除删除的图片
      this.addImg = this.addImg.filter((v) => {
        return v != item;
      });
      this.imgUrlList = this.imgUrlList.filter((v) => {
        return v != item;
      });

      this.$emit("editlist", this.imgUrlList, this.addImg, this.delImg);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/_common.scss";
.image_slot {
  text-align: center;
  line-height: 8rem;
}
.img_list {
  width: 8rem;
  height: 8rem;
  display: inline-block;
  border: $b-border-dashed;
  border-radius: $m-lit;
  margin: $m-lit;
  overflow: hidden;
  position: relative;
  .el-image {
    width: 100%;
    height: 100%;
  }

  .delete_btn {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    left: 0;
    bottom: 0;
    text-align: center;
    line-height: 8rem;
    font-size: $f-hug;
    color: $c-main;
    cursor: pointer;
  }

  &:hover .delete_btn {
    display: block;
  }
}
.upload_img {
  width: 8rem;
  height: 8rem;
  display: inline-block;
  border: $b-border-dashed;
  border-radius: $m-lit;
  margin: $m-lit;
  overflow: hidden;
  position: relative;
  background-color: rgb(249, 249, 249);

  i {
    width: 8rem;
    height: 8rem;
    text-align: center;
    line-height: 8rem;
    font-size: $f-hug;
    color: $c-main;
  }
}
</style>